import {type ColorName, useNamedColor} from '@github-ui/use-named-color'
import {Token} from '@primer/react'
import {clsx} from 'clsx'

import {getTokenStyle} from './Shared'
import styles from './SingleSelectToken.module.css'

type SingleSelectTokenProps = {
  inputName: string
  inputColor: ColorName
}

export const SingleSelectToken = ({inputName, inputColor}: SingleSelectTokenProps) => {
  const color = useNamedColor(inputColor)
  return (
    <Token
      style={{'--token-bg': color.bg, '--token-fg': color.fg, '--token-border': color.border}}
      size="medium"
      text={inputName}
      className={clsx(styles.Token, getTokenStyle(inputName))}
    />
  )
}

export const SingleSelectLeadingVisual = ({inputColor}: Omit<SingleSelectTokenProps, 'inputName'>) => {
  const {bg, accent} = useNamedColor(inputColor)
  return <div style={{'--indicator-bg': bg, '--indicator-border': accent}} className={styles.colorIndicator} />
}
